import { Subject, catchError, of } from 'rxjs';
import { ApiStatus, sidebarList } from '../constants/constants';
import { Injectable, Renderer2, ElementRef } from '@angular/core';
import Drawflow, { ConnectionEvent } from 'drawflow';
import { ConnectionCreated, DoubleClickEvent, ReformatObject, ShapeList, Submenu } from '../interface/flow-builder.interface';
import { HttpService } from './http.service';
import { ApiEndPoints } from '../constants/api-end-points';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class FlowBuilderService {

  public nodeDoubleClick$: any = new Subject<DoubleClickEvent>();
  public nodeConnectionCreated$: any = new Subject<ConnectionCreated>();
  public graphUpdate$: any = new Subject<any>();

  /*
* Public Variables
*/
  public sidebar_data: ShapeList[]|any = sidebarList;
  public drawnNodeList: Submenu[] = [];
  public selectedItem!: Submenu;
  public renderer2!: Renderer2;
  public drawFlowHtmlElement!: HTMLElement;
  public drawflowList!: ElementRef;
  public clickFlag: number = -1;
  public editor!: Drawflow|any;
  public activeNodeIndex: number = -1;
  public activeNode!: Submenu|any;
  public createdConnectionList: ConnectionCreated[] = [];
  public showSettings: boolean = false;
  public sourceFile: string = '';
  public sheetName: { key: string } = { key: '' };
  public sheetNames: any = [];
  public previewDataValues: any = [];
  public gridDataPreview: any = [];
  public selectedFilter: { key: string } = { key: '' };
  public selectedFilterOperator: { key: string } = { key: '' };
  public saveName: any = null;
  public timeStamp: string | any = null;
  public showPreview!: boolean;
  public showPreviewSection: boolean = false;
  public previewData: any[] = [];
  public delimiterSymbol!: string;
  public sampleSize: number = 100;
  public visualizeType: string ='KPI Card';
  public visualizeTitle: string = '';
  public visualizeDescription: string = '';
  public isPublishToIfp:boolean = false;
  public visualizeCharge:number = 0;
  public visualizeComparison: string = '';
  public isLong:boolean = false;
  public tableLoading:boolean = false;
  public dragAreaZoom:number=50;
  public isRun:boolean=false;
  public formData: any = new FormData();
  public previous: any;
  public next: any;
  public selectedAxisValues:any;
  public selectedType: any ;
  public selectedXAxis:any;
  public selectedYAxis:any;

  public fileType!:string;
  
  

  public constFileUpload: Record<string, string> = {
    row: ' row ',
    merges: '!merges',
    column: ' column ',
    toRow: ' to row ',
    empty: '__EMPTY',
    excel: 'excel',
    text: 'text',
    others: 'Others',
    space: 'Space',
    pipe: 'Pipe',
    semicolon: 'Semicolon',
    comma: 'Comma',
    tab: 'Tab',
    tabDelimiter: 'tab',
    spaceDelimiter: 'space',
    ref: '!ref',
    unknown: 'UNKNOWN '
  };

  /*
  * Private Variables
  */
  private dropped: number = -1;
  private connectionData!: ConnectionCreated;
  subs: any;

  constructor(
    private _http:HttpService,
    private http:HttpClient,
    private toast:ToastrService,
    
  ) {}

  /**
 *
 * @param htmlElement
 */
  initDrawFlow(htmlElement: HTMLElement): void {
    this.editor = new Drawflow(htmlElement);
    this.editor.reroute = false;
    this.editor.reroute_fix_curvature = false;
    this.editor.force_first_input = false;
    this.editor['allowMultipleInput'] = false;
    this.editor.start();
    // Node events
    this.editor.on('nodeCreated', (id: number) => {
      this.nodeCreateEvent(id);
    });

    this.editor.on('nodeRemoved', (id: number) => {
      const removeNode = this.drawnNodeList?.findIndex((value: Submenu|any) => +value.id === +id);
      this.drawnNodeList?.splice(removeNode, 1);
      if (this.drawnNodeList?.length === 0) {
        this.showSettings = false;
        this.showPreviewSection = false;
      }
    });
    this.editor.on('connectionCreated', (event: ConnectionCreated) => {

      const outPut = this.editor?.getNodeFromId(event?.output_id);
      const connectionLength = outPut?.outputs[event?.output_class]?.connections?.length;
      if (connectionLength > 1) {
        this.editor?.removeSingleConnection(event?.output_id, event?.input_id, event?.output_class, event?.input_class);
      }
      const inPut = this.editor?.getNodeFromId(event?.input_id);
      const inPutconnectionLength = inPut?.inputs[event?.input_class]?.connections?.length;
      if (inPutconnectionLength > 1) {
        this.editor?.removeSingleConnection(event?.input_id, event?.output_id, event?.input_class, event?.output_class);
      }
      this.connectionCreatedEvent(event);
    });
    this.editor.on('connectionStart', (event: ConnectionEvent) => {
      const path = '.connection path';

      const element = <HTMLElement>document.querySelectorAll(path)[document.querySelectorAll(path)?.length - 1];
      element?.classList?.add('selected');


    });
    this.editor.on('nodeSelected', (id: number) => {
      
      this.nodeSelectedEvent(id);
    });
    this.editor.on('connectionRemoved', (event: ConnectionEvent) => {
      this.connectionRemovedEvent(event);

    });
    this.editor.on('nodeMoved', (id: number) => {
      const nodeStyle = (document?.querySelector(`#node-${id}`) as HTMLElement).style;

      const left = +nodeStyle['left'].toString().replace('px', '');
      const top = +nodeStyle['top'].toString().replace('px', '');

      if (left > 1450) {
        nodeStyle['left'] = '1449px';
      }
      if (top > 400) {
        nodeStyle['top'] = '350px';

      }
      if (top < 90) {
        nodeStyle['top'] = '100px';

      }
      this.editor.updateConnectionNodes(`node-${id}`);

    });


  }



  get flowScale(){
    return  `translate(0px, 0px) scale(${((this.dragAreaZoom * 1.2) / 100) + 0.4})`;
  }


  getRangeChange(){
    // this.drawflowList.nativeElement.children[0].style.transform =  this.flowScale;
  }



  addNodeToDrawBoard(posX: number, posY: number) {
    
    try {
      if (this.editor?.editor_mode === 'edit') {
        posX = (posX * ((this.editor['precanvas']?.clientWidth) / (this.editor['precanvas']?.clientWidth * this.editor?.zoom))) - ((this.editor['precanvas']?.getBoundingClientRect().x) * (this.editor['precanvas']?.clientWidth) / (this.editor['precanvas']?.clientWidth * this.editor?.zoom));
        posY = (posY * ((this.editor['precanvas']?.clientHeight) / (this.editor['precanvas']?.clientHeight * this.editor?.zoom))) - ((this.editor['precanvas']?.getBoundingClientRect().y) * (this.editor['precanvas']?.clientHeight) / (this.editor['precanvas']?.clientHeight * this.editor?.zoom));

        const htmlTemplate = `
            <div class="title-box">
           <img src="${this.selectedItem?.icon}" id="${this.selectedItem?.name}">
            </div>
            <div class="au-nodeName">


            ${this.selectedItem?.name}
            </div>



            `;


        const nodeId = this.editor?.addNode(
          this.selectedItem?.name,
          this.selectedItem?.inputs,
          this.selectedItem?.outputs,
          posX,
          posY,
          this.selectedItem?.name,
          {},
          htmlTemplate,
          false
        );

        this.drawnNodeList?.push({
          ...this.selectedItem,
          id: nodeId
        });
        // This is to get the last create node data
        this.activeNode = this.drawnNodeList[this.drawnNodeList?.length - 1];
        this.onNodeDoubleClick(this.selectedItem?.name, null);
      }
    } catch (error) {
      return;

    }
  }


  private nodeSelectedEvent(id: number) {
    
    this.clickFlag = -1;
    this.drawflowList?.nativeElement?.querySelectorAll('.drawflow-node')?.forEach((element: any) => {
      this.renderer2?.listen(element, 'click', (event: any) => {
        
        if (event?.srcElement?.id === `node-${id}` && this.clickFlag < 0) {
          this.activeNodeIndex = this.drawnNodeList?.findIndex((value: any) => value.id.toString() === id.toString());
          this.activeNode = this.drawnNodeList[this.activeNodeIndex];
          this.onNodeDoubleClick(event?.srcElement?.className?.replace('drawflow-node ', '').replace('selected', '').trim(), event?.srcElement);
          this.clickFlag++;
          return;
        }
        if ((event?.srcElement?.className === 'title-box' && this.clickFlag < 0) || (event.srcElement?.className === 'drawflow_content_node' && this.clickFlag < 0)) {
          this.activeNodeIndex = this.drawnNodeList?.findIndex((value: any) => value.id.toString() === id?.toString());
          this.activeNode = this.drawnNodeList[this.activeNodeIndex];
          this.onNodeDoubleClick(event?.srcElement?.querySelector('img').id, event?.srcElement?.offsetParent);
          this.clickFlag++;
          return;
        }
        if (event.srcElement?.offsetParent?.id === `node-${id}` && this.clickFlag < 0) {
          this.activeNodeIndex = this.drawnNodeList?.findIndex((value: any) => value.id.toString() === id.toString());
          this.activeNode = this.drawnNodeList[this.activeNodeIndex];
          this.onNodeDoubleClick(event?.path[0].id, event?.srcElement?.offsetParent);
          this.clickFlag++;
          return;
        }


      });
    });
    if(!this.isRun && !this.isPublishToIfp){

      this.showPreviewSection = true;
      this.previewData = this.activeNode.connection?.gridData ?? this.previewData;
    }
    
    this.sampleSize = this.activeNode.connection?.gridData?.length ?? this.sampleSize
    
  }


  private nodeCreateEvent(id: number) {
    try {
      if (this.dropped > 0) {
        this.dropped = -1;

        this.editor.removeSingleConnection(this.connectionData?.output_id, this.connectionData?.input_id, this.connectionData?.output_class,
          this.connectionData?.input_class);
        // New O/P to old I/P
        this.editor.addConnection(id, this.connectionData?.input_id, this.connectionData?.output_class, this.connectionData?.input_class);
        this.editor.addConnection(this.connectionData?.output_id, id, this.connectionData?.output_class, this.connectionData?.input_class);
      }
    } catch (error) {

      return;

    }
  }


  private connectionCreatedEvent(event: ConnectionCreated) {
    const pathBeforConnection = `.connection.node_in_node-${event?.input_id}.node_out_node-${event?.output_id}.${event?.output_class}.${event?.input_class} path`;
    document.querySelector(pathBeforConnection)?.classList?.remove('selected');


    const path:any = `.connection.node_in_node-${event?.input_id}.node_out_node-${event?.output_id}.${event?.output_class}.${event?.input_class} path`;
    this.createdConnectionList?.push(event);
    const source = Object.keys(this.drawnNodeList[0]);

    if (source?.includes('connection')) {

      try {
        document.querySelector(path)
          .setAttribute('ondragover', 'this.style.stroke = \'green\'');
        document.querySelector(path).setAttribute('ondragleave', 'this.style.stroke = \'#d4d4d4\'');
      } catch (error) {
        return;

      }

      if (this.dropped < 0) {
        this.connectionData = event;
        this.renderer2?.listen(this.drawflowList?.nativeElement?.querySelector(path), 'drop', () => {
          this.dropped = event ? 1 : -1;
          document.querySelector(path)
            .setAttribute('ondragover', 'event?.preventDefault();this.style?.stroke = \'steelblue\';this.style?.stroke-width = \'4px\'');
        });
      }

      const nextNode = event?.input_id;
      const node = this.editor?.getNodeFromId(nextNode);
      const nodeArrayIndex = this.drawnNodeList?.findIndex((x: any) => x?.id === node?.id);
      this.activeNode = this.drawnNodeList[nodeArrayIndex];
      this.nodeConnectionCreated$.next(event);
      this.onNodeDoubleClick(node.name, null);

    } else {
      this.editor?.removeSingleConnection(event?.output_id, event?.input_id, event?.output_class, event?.input_class);
      // alert('Please add a file');
      this.toast.warning('Please add a file');
      return
    }

  }

  dataToRunApi() {
    this.formData?.delete(`source`);
    this.formData?.delete(`json_data`);
    this.formData?.delete(`workflow_identifier`);
    this.formData?.delete(`sample_size`);
    let delimiterSymbol: string;
    let obj: any = {};
    const gridData: any = {};
    let json = {};

    this.drawnNodeList?.forEach((element: Submenu | any, index: number) => {
      const data = this.editor?.getNodeFromId(element?.id);
      

      if (Object.keys(data?.inputs).length === 0) {
        this.previous = [];
      } else {
        this.previous = Object.keys(data?.inputs)?.map((v: string) => data?.inputs[v]?.connections?.map((c: string | any) => c.node)
        );
      }

      if (data.class === 'Filter') {
        if (Object.keys(data?.outputs?.output_1)?.length === 0) {
          this.next = '';
        } else {
          this.next = Object.keys(data?.outputs)?.map((v: string) => data?.outputs[v]?.connections?.map((c: string | any) => c.node));
        }

        if (Object.keys(data?.outputs?.output_2)?.length === 0) {
          this.next = '';
        } else {
          this.next = Object.keys(data?.outputs)?.map((v: string) => data?.outputs[v]?.connections?.map((c: string | any) => c.node)
          );
        }
      }

      if (Object.keys(data?.outputs)?.length === 0) {
        this.next = '';
      } else {
        this.next = Object.keys(data?.outputs)?.map((v: string) => data?.outputs[v]?.connections?.map((c: string | any) => c.node)
        );
      }


      const key: any = [];
      const value: any = [];

      if (element?.name === 'Select') {
        if (!element['tempData']) {
          element['tempData'] = {};
        }

        element?.reFormat?.forEach((selData: ReformatObject) => {
          if (selData?.checked == true) {

            key?.push(selData?.originalName);
            value?.push(selData?.updatedName ? selData?.updatedName : selData?.originalName);

          }
        });
        element['tempData'] = {};
        for (let i = 0; i < key?.length && i < value?.length; i++) {
          gridData[key[i]] = value[i];
          element['tempData'][key[i]] = value[i];
        }

      }

      if (element?.name === 'Filter') {
        element?.filterFormat?.forEach((filtrData: { key: any; }) => {
          key?.push(filtrData?.key);
        });
        for (let i = 0; i < key?.length; i++) {
          gridData[key[i]] = key[i];
        }
      }



      const leftJoin: any = [];
      const leftValue: any = [];
      const rightJoin: any = [];
      const rightValue: any = [];
      const leftData:any = {};
      const rightData:any = {};

      if (element?.name === 'Join') {
        element?.LeftJoinFormat?.forEach((lft_data: { checked: boolean; key: any; letfUpdatedName: any; }) => {
          if (lft_data?.checked == true) {
            leftJoin?.push(lft_data?.key);
          }
          if (lft_data?.letfUpdatedName == null && lft_data?.checked == true) {
            leftValue?.push(lft_data?.key);
          } else if (lft_data?.letfUpdatedName != null && lft_data?.checked == true) {
            leftValue?.push(lft_data?.letfUpdatedName);
          }
        });
        for (let i = 0; i < leftJoin?.length && i < leftValue?.length; i++) {
          leftData[leftJoin[i]] = leftValue[i];
        }
        element?.RightJoinFormat?.forEach((right_data: { checked: boolean; key: any; rightUpdatedName: any; }) => {
          if (right_data?.checked == true) {
            rightJoin?.push(right_data?.key);
          }
          if (right_data?.rightUpdatedName == null && right_data.checked == true) {
            rightValue?.push(right_data?.key);
          } else if (right_data?.rightUpdatedName != null && right_data.checked == true) {
            rightValue?.push(right_data?.rightUpdatedName);
          }
        });
        for (let i = 0; i < rightJoin.length && i < rightValue.length; i++) {
          rightData[rightJoin[i]] = rightValue[i];
        }
      }

      const next: any = Object.values(this.next);
      const previous = Object.values(this.previous)?.map((v: number | any) => v.toString());

      if (element?.name === 'Source') {
        obj[element?.id] = {
          'fileKey': `Source${[index + 1]}`,
          'next': next?.toString(),
          'node': element?.name.toLowerCase(),
          'previous': previous,
          // 'type': element?.connection_type || null,
          'type': this.fileType,
          'delimeter': delimiterSymbol,
        };
        
        // this.formData?.append(`Source${[index + 1]}`, element?.connection?.file);
        // if(this.formData.get('source')){
        //   let arr:any=[];
        //   arr.push(this.formData.get('source'));
        //   arr.push(element?.connection?.file);
        //   this.formData.delete('source');
        //   console.log(arr);
          
        //   this.formData?.append(`source`,arr)
        // }
        // else{
          this.formData?.append(`source`, element?.connection?.file);
        // }
      } else if (element?.name === 'Select') {

        obj[element?.id] = {
          'next': next?.toString(),
          'node': element?.name?.toLowerCase(),
          'previous': previous
        };
        obj[element?.id]['fields'] = element['tempData'];

      } else if (element?.name === 'Filter') {

        let nxtTrue = null;
        let nxtFalse = null;

        if (next[0] === null && next[1] !== null) {
          nxtTrue = null;
          nxtFalse = Object.values(next[1]);
        } else if (next[0] !== null && next[1] !== null) {
          nxtTrue = Object.values(next[0]);
          nxtFalse = Object.values(next[1]);
        }

        const ftrName = element?.selectedFilter;
        const ftrOperator = element?.operator;
        const ftrValue = element?.value;
        obj[element?.id] = {
          'basic_condition': {
            'filter_field': ftrName || null,
            'filter_operator': ftrOperator || null,
            'filter_value': ftrValue || null
          },
          'custom_conditions': null,
          'true': {
            'next': nxtTrue?.toString() || null
          },
          'false': {
            'next': nxtFalse?.toString() || null
          },
          'node': element?.name?.toLowerCase(),
          'previous': previous
        };
      }else if (element?.name === 'Join') {

        let joinFields = null;
        let inJoinFields = null;
        let rightJoinFields = null;

        if (data?.outputs['output_1']?.connections?.length > 0) {
          joinFields = {
            'left': true,
            'next': next[0]?.toString()
          };
        }
        if (data?.outputs['output_2']?.connections?.length > 0) {
          inJoinFields = {
            'inner': true,
            'next': next[1]?.toString()
          };
        }
        if (data?.outputs['output_3']?.connections?.length > 0) {
          rightJoinFields = {
            'right': true,
            'next': next[2]?.toString()
          };
        }
        obj[element?.id] = {

          'fields': { 'left': leftData, 'right': rightData },
          'left': joinFields,
          'on': {
            'left': element?.leftData || null,
            'right': element?.rightData || null
          },
          'right': rightJoinFields,
          'node': element?.name?.toLowerCase(),
          'inner': inJoinFields,
          'previous': previous
        };
      }
       else if (element?.name === 'Destination') {

        obj[element?.id] = {
          'name': 'dest_'+this.timeStamp,
          'node': 'target',
          'type': 'new',
          'previous': previous
        };
      }
      json = JSON.stringify(obj);

    });

    if (this.timeStamp == null) {
      const timestamp = new Date().getTime();
      this.timeStamp = timestamp;
    }


    this.formData.append('json_data', json);
    this.formData.append('workflow_identifier', this.timeStamp.toString());
    this.formData.append('sample_size', this.sampleSize);
    this.RunApi(this.formData);
  }


    // --- run API integration ---
    RunApi(formData: FormData) {
      this.subs.add(
        this.FlowBuilderRunApi(formData)
        .pipe(
          catchError((e:any)=>{
            return of(false)
          })
        )
        .subscribe((res: any) => {
          
          if (res?.status === ApiStatus.ok) {
            this.toast.success(res?.message);
            this.showPreview = true;
            this.showPreviewSection = true;
          } else {
            this.toast.warning('Run Failed');
          }
        }));
    }

  onNodeDoubleClick(type: string|any, element: HTMLElement|any) {
    this.nodeDoubleClick$.next({ type, element });
  }

  graphUpdate(type:any) {
    this.graphUpdate$.next({ type: type });
  }


  connectionRemovedEvent(event: ConnectionEvent) {
    const index = this.createdConnectionList?.findIndex((x: any) => x?.input_id === event?.input_id);
    this.createdConnectionList?.splice(index, 1);
    const nextNode = event?.input_id;
    const node = this.editor?.getNodeFromId(nextNode);
    const nodeArray:any = this.drawnNodeList?.find((x: any) => x?.id === node?.id);
    if (node?.name === 'Select') {
      nodeArray.reFormat = [];
    } else if (node?.name === 'Filter') {
      nodeArray.filterFormat = [];
    } else if (node?.name === 'Join') {
      if (event.input_class === 'input_1') {
        nodeArray.LeftJoinFormat = [];
      }
      if (event.input_class === 'input_2') {
        nodeArray.RightJoinFormat = [];
      }
    }

  }



  onDragOver(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
  }


  onDrop(e: MouseEvent) {
    // After dropping the element, create a node
    if (e.type === 'drop') {
      e.preventDefault();
      this.addNodeToDrawBoard(e.clientX, e.clientY);
      this.showSettings = true;
      this.showPreview = false;
    }

  }

  // API INTEGRATION

  FlowBuilderRunApi(data: FormData) {
    return this._http.post(`${ApiEndPoints.runFlowBuilder}`, data);
  }

  FlowBuilderPreviewApi(Id: string | number, name: string, timestamp: any) {
    return this._http.get(`${ApiEndPoints.flowBuilderPreviewApi}?node_id=${Id}&node_name=${name}&workflow_identifier=${timestamp}&timeStamp=${timestamp}`);
  }

  FlowBuilderPublishApi(data: FormData) {
    return this._http.post(`${ApiEndPoints.FlowBuilderPublishApi}`, data);
  }

  getTableDetails(name: string) {
    return this.http.get(`http://etl.beinex.com/api/v1/table/field/list?table_name=${name}`);
  }

  createTableForGraph(data: FormData) {
    return this.http.post(`http://etl.beinex.com/api/v1/destination-tool/create`, data);
  }

  updateTableForGraph(data: FormData,id:string) {
    return this.http.put(`http://etl.beinex.com/api/v1/destination-tool/update/${id}`, data);
  }

  getGraphTableDetail(name: string) {
    return this.http.get(`http://etl.beinex.com/api/v1/kpi-card/detail?table_name=${name}`);
  }

  getLineGraph(name:string,request_for:string){
    return this.http.get(`http://etl.beinex.com/api/v1/filtercharts?table_name=${name}&request_for=${request_for}`);
  }

  getCardCharges(name: string,x_data:string,y_data:string) {
    return this.http.get(`http://etl.beinex.com/api/v1/kpi-card/comparison/data?table_name=${name}&y_data=${y_data}&x_data=${x_data}`);
  }

}
